import React from 'react';

const ProfessionalServices: React.FC = () => {
  return (
    <div className="page professional-services">
      <div className="container">
        <h1>Professional Services</h1>
        <p className="intro">
          I offer comprehensive DevOps and Cloud consulting services to help organizations 
          accelerate their digital transformation journey. With years of experience in the field, 
          I provide tailored solutions that drive efficiency, reliability, and scalability.
        </p>

        <section className="services-section">
          <div className="services-grid">
            
            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-chalkboard-teacher"></i>
              </div>
              <h3>Trainings</h3>
              <p>
                Comprehensive training programs designed to upskill your team in modern collaboration techniques, 
                communication skills, and professional development. From Liberating Structures to Public Speaking 
                Mastery, our workshops transform organizational capabilities.
              </p>
              <div className="service-details">
                <a href="/trainings" className="service-link">View Training Catalog</a>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-chart-line"></i>
              </div>
              <h3>Assessment</h3>
              <p>
                Thorough evaluation of your current DevOps maturity, infrastructure setup, 
                and development processes. Receive actionable insights and roadmaps for 
                improvement with detailed recommendations.
              </p>
              <div className="service-details">
                <span className="coming-soon">Details coming soon...</span>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-cloud"></i>
              </div>
              <h3>Cloud Consulting</h3>
              <p>
                Strategic guidance for cloud adoption, migration, and optimization. 
                Expertise in AWS, Azure, and multi-cloud architectures to help you 
                leverage cloud technologies effectively and cost-efficiently.
              </p>
              <div className="service-details">
                <span className="coming-soon">Details coming soon...</span>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-code"></i>
              </div>
              <h3>Infrastructure as Code (IaC) Consulting</h3>
              <p>
                Implementation and optimization of Infrastructure as Code practices using 
                tools like Terraform, CloudFormation, and Ansible. Automate your infrastructure 
                provisioning and management for consistency and reliability.
              </p>
              <div className="service-details">
                <span className="coming-soon">Details coming soon...</span>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fa-solid fa-infinity"></i>
              </div>
              <h3>CI/CD Consulting</h3>
              <p>
                Design and implementation of robust CI/CD pipelines that accelerate software 
                delivery while maintaining quality and security. Expertise in various tools 
                and platforms to create efficient automation workflows.
              </p>
              <div className="service-details">
                <span className="coming-soon">Details coming soon...</span>
              </div>
            </div>

          </div>
        </section>

        <section className="contact-cta">
          <div className="cta-content">
            <h2>Ready to Transform Your DevOps Journey?</h2>
            <p>Let's discuss how I can help your organization achieve its goals.</p>
            <a href="/contact" className="cta-button">Get in Touch</a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProfessionalServices;